import {images} from '../../styles/global';
import * as S from './style';

const Maintenance = () => {
  return (
    <S.MaintenancePageContent>
      <h1>Estamos em adaptação</h1>
      <h2>Em breve, você poderá acessar nosso site novamente</h2>
      <br />

      <a href="https://educa.mobilithas.com.br">
        Para ter acesso aos cursos, clique aqui:{' '}
        <span>https://educa.mobilithas.com.br</span>
      </a>

      <img src={images.pages.maintenance.cargoBike} alt="Cargo Bike" />
    </S.MaintenancePageContent>
  );
};

export default Maintenance;
